/** Une destination explicite reste dans l'application, même après normalisation de l'URL. */
export function appDestination(appId: string, route: string): string | null {
  if (!/^[a-z][a-z0-9_-]*$/u.test(appId) || !route.startsWith('/') || route.startsWith('//'))
    return null;
  try {
    const base = `/app/${appId}`;
    const url = new URL(`${base}${route}`, 'https://ndrc.invalid');
    const pathname = decodeURIComponent(url.pathname);
    if (pathname !== base && !pathname.startsWith(`${base}/`)) return null;
    if (pathname.includes('\\') || pathname.split('/').includes('..')) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
